
    <spaq-confirm-password></spaq-confirm-password>
  


// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/containers/confirm-password-page.component.ts.ConfirmPasswordPageComponent.html